import styled, { keyframes } from 'styled-components';

/* soft concentric "on air" waves around the call icon while talking */
const callRipple = keyframes`
  0%   { transform: scale(0.65); opacity: 0.75; }
  100% { transform: scale(1.9);  opacity: 0; }
`;

/* centered over the tile; width auto so translate lands it dead-center,
   same technique as the event badge which already sits centered */
export const Content = styled.div`
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 130;
  display: inline-flex;
  justify-content: center;
  align-items: flex-start;
  pointer-events: none;
  & > * {
    pointer-events: auto;
  }
`;

/* wrapper so the "on air" waves can sit centered behind the icon */
export const CallBadge = styled.div`
  position: relative;
  display: inline-flex;
`;

/* pulsing rings shown only while the call is active (talking) */
export const CallWaves = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 34px;
  height: 34px;
  margin: -17px 0 0 -17px;
  pointer-events: none;
  z-index: 8;
  &::before,
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 2px solid rgba(67, 182, 230, 0.6);
    animation: ${callRipple} 1.9s ease-out infinite;
  }
  &::after {
    animation-delay: 0.95s;
  }
  @media (prefers-reduced-motion: reduce) {
    &::before,
    &::after {
      animation: none;
    }
  }
`;

export const CallIcon = styled.img`
  z-index: 9;
  position: relative;
  width: 38px;
  cursor: pointer;

  @keyframes bounce {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      transform: translate3d(0, -50px, 0);
    }
  }

  /* bounce only while waiting (a new call begging to be answered);
     once the conversation is on, hold steady and let the waves speak */
  ${(props) =>
    props.status === 'active'
      ? ''
      : `
    animation: bounce 0.5s;
    animation-direction: alternate;
    animation-timing-function: cubic-bezier(0.5, 0.05, 1, 0.5);
    animation-iteration-count: infinite;
  `}
`;

export const CallBlock = styled.div`
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  pointer-events: auto;
  border-radius: 5px;
  background-color: #000000;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.58);
  width: 205px;
  height: 115px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 999;
  /* невидимый мостик к Tip, чтобы hover не терялся */
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    height: 10px;
  }
  img {
    height: 47px;
    width: 47px;
    margin-bottom: 10px;
  }
  span {
    color: white;
    opacity: 0.6;
  }
`;

export const CallIndicator = styled.div`
  pointer-events: none;
  position: absolute;
  top: 23px;
  left: -6px;
  width: 50px;
  height: 88px;
  opacity: 0.4;
  border-radius: 3px;
  background-color: #16b6f0;
`;

export const ButtonBlock = styled.div`
  text-align: center;
  cursor: pointer;
`;
